import React from "react"
import { Link } from "gatsby"

import { useLocale } from "context/locale"
import useResponsive from "hooks/useResponsive"

import IcoMission from "assets/icons/header-mission.svg"
import IcoMissionLarge from "assets/icons/header-mission-large.svg"
import IcoCareers from "assets/icons/header-careers.svg"
import IcoCareersLarge from "assets/icons/header-careers-large.svg"
import IcoMedia from "assets/icons/header-media.svg"
import IcoMediaLarge from "assets/icons/header-media-large.svg"
import IcoRoadmap from "assets/icons/header-roadmap.svg"
import IcoRoadmapLarge from "assets/icons/header-roadmap-large.svg"
import IcoPartner from "assets/icons/header-partner.svg"
import IcoPartnerLarge from "assets/icons/header-partner-large.svg"
import IcoGrants from "assets/icons/header-grants.svg"
import IcoGrantsLarge from "assets/icons/header-grants-large.svg"

const CompanySubmenu = ({ onClick }) => {
  const { t } = useLocale()
  const { isDesktop } = useResponsive()

  return (
    <div className="header__submenu">
      <Link to={t("/company/mission/")} onClick={onClick}>
        <span>
          <img src={isDesktop ? IcoMission : IcoMissionLarge} alt="" />
        </span>
        {t("Mission")}
      </Link>
      <Link to={t("/company/careers/")} onClick={onClick}>
        <span>
          <img src={isDesktop ? IcoCareers : IcoCareersLarge} alt="" />
        </span>
        {t("Careers")}
      </Link>
      <Link to={t("/company/media-and-press-materials/")} onClick={onClick}>
        <span>
          <img src={isDesktop ? IcoMedia : IcoMediaLarge} alt="" />
        </span>
        {t("Media & Press")}
      </Link>
      <Link to={t("/company/roadmap/")} onClick={onClick}>
        <span>
          <img src={isDesktop ? IcoRoadmap : IcoRoadmapLarge} alt="" />
        </span>
        {t("Roadmap")}
      </Link>
      <Link to={t("/company/become-a-partner/")} onClick={onClick}>
        <span>
          <img src={isDesktop ? IcoPartner : IcoPartnerLarge} alt="" />
        </span>
        {t("Become a Partner")}
      </Link>
      <Link to={t("/company/grants/")} onClick={onClick}>
        <span>
          <img src={isDesktop ? IcoGrants : IcoGrantsLarge} alt="" />
        </span>
        {t("Grants")}
      </Link>
    </div>
  )
}

export default CompanySubmenu
